import React, { useEffect, useState } from 'react';
import { CustomTooltip } from '../tooltip/CustomTooltip';
import { tooltipContents } from '../tooltip/Const';
import {
  Checkbox,
  IconButton,
  styled,
  TableCell,
  TableRow,
  TextField
} from '@material-ui/core';
import { parsePrice } from '../../utils';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles
} from '@material-ui/core/styles';
import { useRecoilState, useSetRecoilState } from 'recoil';
import {
  additionalCostData,
  btnColor,
  mainBlueColor,
  workingBudgetData,
  workingBudgetVendor,
  inputAdditionalCostState,
  saveTimeStateData
} from '../../GlobalState';
import {
  TypeLayer,
  TypeRow,
  TypeVendorInfo
} from '../../types/WorkingBudgetPage';
import _ from 'lodash';
import { getUnitMasterList } from '../../apicalls/unitMaster';
import { Vender } from './Vender';
import { AdditionalCostVender } from './AdditionalCostVender';
import {
  NOT_LOGGED_IN,
  LOCAL_STORAGE_SAVE_TIME,
  LOCAL_WORKING_BUDGET_KEY,
  LOCAL_STORAGE_NEW_WORKING_BUDGET_KEY
} from '../../const/Const';
import NumberInput from '../NumberInput';
import { recalculation } from '../../utils/WorkingBudgetPage';
import { getCostPriceBackgroundColor } from './CostPriceBackgroudColor';
import { useParams } from 'react-router-dom';
import { calcTotalFromQuantityAndUnitPrice } from '../../utils/calcRules';

const StyledTableCell = withStyles(theme => ({
  root: {
    backgroundColor: '#FFF'
  },
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      // backgroundColor: theme.palette.action.hover,
      '&:hover': {
        backgroundColor: '#CFCFCF'
      }
    }
  }
}))(TableRow);

const StyledIconCell = withStyles(theme => ({
  root: {
    padding: 0
  }
}))(TableCell);

// カラムの横幅
const colWidth = {
  icon: 50, // 階層アイコン
  itemName: 225, // 項目
  details: 225, // 仕様・詳細
  budgetQuantity: 100, // 数量
  budgetUnit: 75, // 単位
  estimatedPrice: 130, // 見積 単価
  estimatedAmount: 130, // 見積 金額
  costPrice: 130, // 原価 単価
  costAmount: 130 // 原価 金額
};

type TProps = {
  isDetailShow: boolean;
  data: TypeRow;
  indent: number;
  changeLoggedInData: any;
  setErrorMessage: any;
  setOpen: any;
  selectItems?: number[];
  setSelectItems?: any;
  workingBudgetId: number;
  reflectData: boolean;
};

export const AdditionalCostTableItemRow: React.FC<TProps> = (props: TProps) => {
  const {
    isDetailShow,
    data,
    indent,
    selectItems,
    setSelectItems,
    changeLoggedInData,
    setErrorMessage,
    setOpen,
    workingBudgetId,
    reflectData
  } = props;

  const [tableSized, setTableSized] = useState<number>(100);
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);
  const classes = useStyles({ mainColor: mainColor, tableSized: tableSized });
  const [vendor] = useRecoilState(workingBudgetVendor);
  const [additionalCost, setAdditionalCost] =
    useRecoilState(additionalCostData);
  const [workingBudget, setWorkingBudget] = useRecoilState(workingBudgetData);
  const [saveTime, setSaveTime] = useRecoilState(saveTimeStateData);
  const [mUnitsData, setMUnitsData] = useState([]);
  const [costPrice, setCostPrice] = useState<number>(0);
  const [name, setName] = useState('');
  const [detail, setDetail] = useState('');
  const [quantity, setQuantity] = useState<number | undefined>(0);
  const [unit_id, setUnitId] = useState<number | undefined>(0);
  const [cost_unit_price, setCostUnitPrice] = useState<number>(0);
  const params: any = useParams();
  const [costPriceBackgroundColor, setCostPriceBackgroundColor] = useState('');
  const [isFocus, setFocus] = useState(false);

  useEffect(() => {
    const costPriceBackgroundColor = getCostPriceBackgroundColor(
      data.vendor_order_price,
      costPrice
    );
    setCostPriceBackgroundColor(costPriceBackgroundColor);
  }, [data.vendor_order_price, costPrice]);

  useEffect(() => {
    getUnitMasterList().then(data => {
      if (data === NOT_LOGGED_IN) {
        changeLoggedInData(NOT_LOGGED_IN);
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setMUnitsData(data.data);
          }
        }
      }
    });

    setName(data.name);
    setDetail(data.detail);
    setQuantity(data.quantity);
    setUnitId(data.unit_id);
    setCostUnitPrice(data.cost_unit_price);
    setCostPrice(data.quantity * data.cost_unit_price);
  }, [reflectData, additionalCost]);

  useEffect(() => {
    const cloneAdditionalCostIndex = additionalCost.findIndex(
      i => i.id == data.id
    );
    if (cloneAdditionalCostIndex != -1) {
      setCostPrice(
        additionalCost[cloneAdditionalCostIndex]['cost_unit_price'] *
          additionalCost[cloneAdditionalCostIndex]['quantity']
      );
    }
  }, [additionalCost.length]);

  const check = (val: any) => {
    if (selectItems) {
      let arr = _.cloneDeep(selectItems);
      if (val.target.checked) {
        if (data.id) {
          arr.push(data.id);
        }
      } else {
        arr = arr.filter(item => item != data.id);
      }
      setSelectItems(arr);
    }
  };

  const onChange = (val: any, key: string) => {
    if (key == 'quantity' && !/^\d*\.?\d*$/.test(val)) return;
    let inputVal = val;
    if (key == 'cost_unit_price') {
      inputVal = val ? val : 0;
    }
    const cloneAdditionalCost: any[] = _.cloneDeep(additionalCost);
    const cloneAdditionalCostIndex = cloneAdditionalCost.findIndex(
      i => i.id == data.id
    );
    if (cloneAdditionalCostIndex != -1) {
      cloneAdditionalCost[cloneAdditionalCostIndex][key] = inputVal;
    }

    if (key == 'name') {
      setName(inputVal);
      setAdditionalCost(cloneAdditionalCost);
      return;
    }
    if (key == 'detail') {
      setDetail(inputVal);
      setAdditionalCost(cloneAdditionalCost);
      return;
    }

    if (key == 'quantity') {
      setQuantity(inputVal);
      setCostPrice(
        calcTotalFromQuantityAndUnitPrice(
          inputVal,
          cloneAdditionalCost[cloneAdditionalCostIndex]['cost_unit_price']
        )
      );
    }

    if (key == 'cost_unit_price') {
      setCostUnitPrice(inputVal);
      setCostPrice(
        calcTotalFromQuantityAndUnitPrice(
          cloneAdditionalCost[cloneAdditionalCostIndex]['quantity'],
          inputVal
        )
      );
    }

    setAdditionalCost(cloneAdditionalCost);
  };

  const setInputAdditionalCosState = useSetRecoilState(
    inputAdditionalCostState
  );
  const setState = (data: number) => {
    setInputAdditionalCosState(data);
  };

  // ローカルストレージで保存する際のキー(実行予算用)
  // 新規作成：working_budget_id_実行予算ID / 編集：working_budget_実行予算ID
  const setKey = params.id
    ? LOCAL_WORKING_BUDGET_KEY + params.id
    : LOCAL_STORAGE_NEW_WORKING_BUDGET_KEY + workingBudgetId;
  /**
   * ローカルストレージへの保存処理
   * @param key
   * @param value
   */
  const setLocalStorage = (
    key: 'name' | 'detail' | 'quantity' | 'unit_id' | 'cost_unit_price',
    value: string
  ) => {
    let setData = {
      name: '',
      detail: '',
      quantity: '',
      unit_id: '',
      cost_unit_price: '',
      time: ''
    };

    // ローカルストレージのデータを取得
    const localStorageData = localStorage.getItem(setKey);

    // ローカルストレージのデータが存在する場合
    if (localStorageData) {
      // 設定データに取得した既存データを設定
      setData = JSON.parse(localStorageData);
    }

    // 対象のキーの値を更新
    setData[key] = value;

    // 保存時間を設定
    const now = new Date();
    const time = `${now.getFullYear()}/${('0' + (now.getMonth() + 1)).slice(
      -2
    )}/${('0' + now.getDate()).slice(-2)} ${('0' + now.getHours()).slice(
      -2
    )}:${('0' + now.getMinutes()).slice(-2)}:${('0' + now.getSeconds()).slice(
      -2
    )}`;
    setData.time = time;

    const object = {
      additionalCost: additionalCost,
      workingBudget: workingBudget,
      time: time
    };

    localStorage.setItem(setKey, JSON.stringify(object));
    setSaveTime(time);
  };

  return (
    <StyledTableRow className='click_table_row' style={{ height: 70 }}>
      {/* 選択削除用チェックボックス */}
      <StyledIconCell
        style={{
          position: 'sticky',
          width: colWidth.icon,
          left: 0,
          backgroundColor: '#ffffff',
          zIndex: 5,
          border: '0.5px #CCCCCC solid'
        }}
        align='center'
      >
        <Checkbox
          checked={selectItems && selectItems.some(i => i == data.id)}
          onChange={check}
          style={{
            color: buttonColor
          }}
        />
      </StyledIconCell>
      {/* 項目名 */}
      <StyledTableCell
        className={classes.table1}
        align='center'
        style={{
          backgroundColor: '#ffffff',
          position: 'sticky',
          width: colWidth.itemName,
          left: 50,
          zIndex: 1,
          border: '0.5px #CCCCCC solid'
        }}
      >
        <TextField
          variant='outlined'
          style={{ width: '100%' }}
          size='small'
          inputProps={{ style: { textAlign: 'left' } }}
          value={name}
          onChange={e => onChange(e.target.value, 'name')}
          onBlur={text => {
            setLocalStorage('name', text.target.value);
          }}
        />
      </StyledTableCell>

      {isDetailShow ? (
        <>
          {/* 仕様・詳細 */}
          <StyledTableCell
            className={classes.table1}
            align='center'
            style={{
              backgroundColor: '#ffffff',
              position: 'sticky',
              width: colWidth.details,
              left: 275,
              zIndex: 1,
              border: '0.5px #CCCCCC solid'
            }}
          >
            <TextField
              variant='outlined'
              style={{ width: '100%' }}
              size='small'
              inputProps={{ style: { textAlign: 'left' } }}
              value={detail}
              onChange={e => onChange(e.target.value, 'detail')}
              onBlur={text => {
                setLocalStorage('detail', text.target.value);
              }}
            />
          </StyledTableCell>
        </>
      ) : (
        <></>
      )}
      {/* 数量 */}
      <StyledTableCell
        className={classes.table1}
        align='center'
        style={{
          backgroundColor: '#ffffff',
          position: 'sticky',
          width: colWidth.budgetQuantity,
          left: 500 - (isDetailShow ? 0 : 225),
          zIndex: 1,
          border: '0.5px #CCCCCC solid'
        }}
      >
        <TextField
          variant='outlined'
          style={{ width: '100%' }}
          type='number'
          size='small'
          inputProps={{ style: { textAlign: 'right' } }}
          value={
            quantity !== 0 || isFocus
              ? quantity
                ? quantity.toString()
                : ''
              : '0'
          }
          onFocus={() => {
            setFocus(true);
          }}
          onBlur={e => {
            setFocus(false);
            if (e.target.value === '') {
              setLocalStorage('quantity', '0');
              onChange(0, 'quantity');
            } else {
              setLocalStorage('quantity', e.target.value);
              onChange(Number(e.target.value), 'quantity');
            }
          }}
          onChange={e => {
            const newValue = Number(e.target.value);
            if (!isNaN(newValue)) {
              onChange(newValue, 'quantity');
            }
          }}
        />
      </StyledTableCell>
      {/* 単位 */}
      <StyledTableCell
        className={classes.table1}
        align='center'
        style={{
          backgroundColor: '#ffffff',
          position: 'sticky',
          width: '100%',
          left: 600 - (isDetailShow ? 0 : 225),
          zIndex: 1,
          border: '0.5px #CCCCCC solid',
          paddingBottom: 8
        }}
      >
        <select
          onChange={e => onChange(Number(e.target.value), 'unit_id')}
          className={classes.selectBoxStyleItems}
          name='cars'
          form='carform'
          value={unit_id}
          style={{ borderRadius: '5px', padding: 10 }}
          onBlur={text => {
            setLocalStorage('unit_id', text.target.value);
          }}
        >
          <option value='0'>--</option>
          {mUnitsData.map((i: any) => (
            <option value={i.id}>{i.name}</option>
          ))}
        </select>
      </StyledTableCell>
      {isDetailShow ? (
        <>
          {/* 見積単価*/}
          <StyledTableCell
            className={classes.table1}
            align='center'
            style={{
              backgroundColor: '#ffffff',
              position: 'sticky',
              width: colWidth.estimatedPrice,
              left: 675,
              zIndex: 1,
              border: '0.5px #CCCCCC solid'
            }}
          >
            -
          </StyledTableCell>
          {/* 見積金額*/}
          <StyledTableCell
            className={classes.table1}
            align='center'
            style={{
              backgroundColor: '#ffffff',
              position: 'sticky',
              width: colWidth.estimatedAmount,
              left: 805,
              zIndex: 1,
              border: '0.5px #CCCCCC solid'
            }}
          >
            -
          </StyledTableCell>
        </>
      ) : (
        <></>
      )}
      {/* 追加原価単価 */}
      <StyledTableCell
        className={classes.table1}
        align='center'
        style={{
          backgroundColor: '#ffffff',
          position: 'sticky',
          width: colWidth.costPrice,
          left: 935 - (isDetailShow ? 0 : 485),
          zIndex: 1,
          border: '0.5px #CCCCCC solid'
        }}
      >
        <TextField
          variant='outlined'
          style={{ width: '100%' }}
          size='small'
          inputProps={{ style: { textAlign: 'right' } }}
          value={
            cost_unit_price !== 0 || isFocus
              ? cost_unit_price
                ? cost_unit_price.toString()
                : ''
              : '0'
          }
          onFocus={() => {
            setFocus(true);
            if (cost_unit_price === 0) {
              onChange('', 'cost_unit_price');
            }
          }}
          onBlur={e => {
            setFocus(false);
            if (e.target.value === '') {
              setLocalStorage('cost_unit_price', '0');
              onChange(0, 'cost_unit_price');
            } else {
              setLocalStorage('cost_unit_price', e.target.value);
              onChange(Number(e.target.value), 'cost_unit_price');
            }
          }}
          onChange={e => onChange(e.target.value, 'cost_unit_price')}
        />
      </StyledTableCell>
      {/* 追加原価金額 */}
      <StyledTableCell
        className={classes.tableNum}
        align='right'
        style={{
          backgroundColor: costPriceBackgroundColor,
          position: 'sticky',
          width: colWidth.costAmount,
          left: 1065 - (isDetailShow ? 0 : 485),
          zIndex: 1,
          border: '0.5px #CCCCCC solid'
        }}
      >
        {parsePrice(costPrice)}
      </StyledTableCell>
      {vendor &&
        vendor.length > 0 &&
        vendor.map((v: TypeVendorInfo) => (
          <AdditionalCostVender
            data={data}
            vender={v}
            workingBudgetId={workingBudgetId}
          />
        ))}
    </StyledTableRow>
  );
};

type TStyleProps = {
  mainColor: string;
  tableSized: number;
};

const useStyles = makeStyles<Theme, TStyleProps>((theme: Theme) =>
  createStyles({
    table1: {
      padding: 8,
      paddingBottom: 3
    },
    tableNum: {
      paddingRight: 10
    },
    tableInput: {
      padding: 0,
      paddingRight: 10,
      paddingLeft: 10
    },
    selectBoxStyleItems: {
      WebkitAppearance: 'menulist-button',
      backgroundColor: 'white',
      borderColor: '#c1c1c1',
      height: 40,
      width: '100%'
    }
  })
);
